import { createFileRoute } from "@tanstack/react-router";
import AdminLayout from "@/components/admin/AdminLayout";

// AdminLayout performs the auth + admin-role gate internally and renders <Outlet />
// for all nested /admin/* child routes.
export const Route = createFileRoute("/admin")({
  component: () => <AdminLayout />,
});
